// confirmation modal to prevent users from commiting actions that cannot be undone

import React from 'react';
import { Modal, Button, Header } from 'semantic-ui-react';

const ConfirmationModal = ({ open, onClose, onConfirm, message, confirmText, cancelTextBool = true}) => (
  <Modal
    open={open}
    onClose={onClose}
    size="tiny"
  >
    <Header content="Confirmation" />
    <Modal.Content>
      <p>{message}</p>
    </Modal.Content>
    <Modal.Actions>
      {cancelTextBool && <Button color='black' onClick={onClose}>
        Cancel
      </Button>}
      <Button positive onClick={onConfirm}>
        { confirmText ? confirmText : 'Confirm action' }
      </Button>
    </Modal.Actions>
  </Modal>
);

export default ConfirmationModal;
